import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './../auth.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-auth-code',
  templateUrl: './auth-code.component.html',
  styleUrls: ['./auth-code.component.scss'],
})
export class AuthCodeComponent implements OnInit {
  api_url = environment.api_endpoint;
  forgotForm!: FormGroup;
  auth_code: any;
  isActive = false;
  disableButton = false;
  disableButton_submit = false;
  userid: any;
  counter: any;
  resend_flag: any = 0;
  errMsg = '';
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar
  ) {
    this.userid = this.route.snapshot.params.userId;
  }

  ngOnInit() {
    if (!this.authService.userResetInfo)
      this.router.navigate(['forgot-password']);
    this.start();
    this.forgotForm = this.formBuilder.group({
      authcode: ['', [Validators.required]],
    });
  }

  submit() {
    this.disableButton_submit = true;
    let data = {
      userId: this.userid,
      otp: this.auth_code,
    };
    const preparedObj = this.authService.userResetInfo;
    Object.assign(preparedObj, { oneTimePassword: this.auth_code });
    // Send http request
    this.authService.validate_otp(preparedObj).subscribe(
      (res) => {
        this.router.navigate(['/reset-password']);
        localStorage.setItem('jwt_token', res.headers.get('authorization'));
        this.snackBar.open('Authorization code verified', '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
      },
      (err) => {
        console.log('err:', err);
        this.errMsg = err?.error?.message || 'Something went wrong !';
        this.forgotForm.get('authcode')?.setErrors({ invalidCode: true });
        this.disableButton_submit = false;
      }
    );
  }
  start() {
    this.counter = 30;
    let intervalId = setInterval(() => {
      this.counter -= 1;
      if (this.counter === 0) {
        clearInterval(intervalId);
        this.resend_flag = 1;
        this.disableButton_submit = false;
      }
    }, 1000);
  }
  resend() {
    this.disableButton = true;
    let path = 'send-otp';
    const obj = this.authService.resetObj;
    this.authService.forgot_password(path, obj).subscribe(
      (res: any) => {
        let message =
          'Authorization Code is sent to your registered Email';
        this.snackBar.open(message, '', {
          duration: 5000,
        });
        this.resend_flag = 0;
        this.disableButton = false;
        this.start();
      },
      (error) => {
        this.disableButton = false;
        this.snackBar.open('Failed to send Email', '', {
          duration: 5000,
        });
      }
    );
  }
}
